import { render, staticRenderFns } from "./TableRevisionsSelector.vue?vue&type=template&id=bacaee4e"
import script from "./TableRevisionsSelector.vue?vue&type=script&lang=js"
export * from "./TableRevisionsSelector.vue?vue&type=script&lang=js"
import style0 from "./TableRevisionsSelector.vue?vue&type=style&index=0&id=bacaee4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports